import React from "react";

import { graphql } from "gatsby";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";

import DropdownFormField from "../../components/dynamicForm/dropdownFormField/dropdownFormField";
import { isRequired } from "../../components/dynamicForm/dynamicFormUtils";
import Tooltip from "../../components/localForms/tooltip";

const KontentItemInputTypeState = ({
  data: { elements },
  errors,
  touched,
  values,
  meta,
  onChange,
  onBlur,
}) => (
  <Col xs={12} md={6}>
    <Tooltip
      id={elements.id.value}
      tooltipMessage={elements.tooltip.value}
    >
      <DropdownFormField
        id={elements.id.value}
        type="select"
        errors={errors}
        touched={touched}
        values={values}
        meta={meta}
        name={elements.label.value}
        label={elements.label.value}
        placeholder={elements.placeholder_state.value}
        options={elements.options.value?.split("\n").map((item) => ({ label: item, value: item }))}
        onChange={onChange}
        onBlur={onBlur}
        required={isRequired(elements.id.value, elements.required.value)
          || meta?.requiredFields?.includes(elements.id.value)}
      />
    </Tooltip>
  </Col>
);

export const query = graphql`
  fragment KontentItemInputTypeState on kontent_item_input_type_state {
    id
    elements {
      id {
        value
      }
      label {
        value
      }
      placeholder_state {
        value
      }
      options {
        value
      }
      required {
        value {
          codename
        }
      }
      tooltip {
        value
      }
    }
  } 
`;

KontentItemInputTypeState.propTypes = {
  data: PropTypes.oneOfType([PropTypes.object]).isRequired,
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  meta: PropTypes.oneOfType([PropTypes.object]).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  values: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default KontentItemInputTypeState;
